<template>
	<div class="ss-recmd-box" :style="{backgroundColor: bgColor}">
		<div class="ss-recmd__title" v-if="title_">
			<div class="fr" v-if="showRefresh_" @click="initRecmd">
				<img src="../../assets/img/main/gengxin.png" />换一批
			</div>
			{{title_}}
		</div>
		<ul class="ss-recmd-list">
			<li class="clearfix" v-for="(item, index) in recmdList" :key="index" @click="goDetail(item.id)">
				<img :src="(item.url ? item.url : item.attrs.listPic) | imgUrl" class="ss-recmd__img poster-image" />
				<div class="ss-recmd__content">
					<p class="ss-recmd__text">{{item.title}}</p>
					<div class="ss-recmd__num">
						<img src="../../assets/img/culturalActivity/iconfontrenshu.png" />
						<span>{{item.views | unit}}</span>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	let detailName = '', channelPaths = '';
	export default {
		data() {
			return {
				recmdList: []
			}
		},
		props:{
			title: {
				type: [Boolean, String],
				default: false
			},
			showRefresh: {
				type: [Boolean, String],
				default: false
			},
			bgColor: {
				type: String,
				default: '#fff'
			}
		},
		computed: {
			showRefresh_() {
				return String(this.showRefresh) === 'false' ? false : true;
			},
			title_() {
				return String(this.title) === 'false' ? false : this.title;
			}
		},
		created() {
			this.initRecmd();
		},
		methods: {
			initRecmd() {
				let routerName = this.$route.name;
				switch (routerName){
					case 'culturalActivity':
					case 'culturalActivityDetail':
						detailName = '/cultureAround/activity/';
						this.hotActivityPage();
						break;
					case 'culturalInfo':
					case 'culturalInfoDetail':
						detailName = '/cultureAround/info/';
						channelPaths = 'qwxx,tzgg,whzc,ycsf';
						this.indexNews();
						break;
					case 'behExhibitionn':
					case 'behExhibitionnDetail':
						detailName = '/brilliantEHome/exhibition/';
						channelPaths = 'jczlsy,jczlsh,jczlfy,jczlqt';
						this.indexNews();
						break;
					case 'volunteerHomeElegant':
					case 'volunteerHomeElegantDetail':
						detailName = '/volunteerHome/elegantShow/';
						channelPaths = 'fczswhzyz,fczswhzyzfwxm';
						this.indexNews();
						break;
					default:
						break;
				}
			},
			async hotActivityPage() {
				let res = await this.$http('hotActivityPage');
				res.code === 1 && (this.recmdList = res.data.content || []);
			},
			async indexNews() {
				let res = await this.$http('indexNews', {
					channelPaths: channelPaths,
					count: 10
				});
				res.code === 1 && (this.recmdList = res.data || []);
			},
			goDetail(id) {
				this.$router.push({
					path: detailName + id
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.ss-recmd-box{
		border-top: 3px solid #0260FE;
		.ss-recmd-list{
			li{
				padding: 13px;
				cursor: pointer;
				.ss-recmd__img{
					float: left;
					width:59px;
					height:57px;
				}
				&:hover{
					.ss-recmd__text{
						color: #0260FE;
					}
				}
				.ss-recmd__num{
					@include abs(null, 0, 0, 20px);
					font-size:16px;
					font-weight:400;
					color: #5B5B5B;
					line-height:18px;
					img{
						margin-right: 5px;
						width:16px;
						height:13px;
						display: inline-block;
						vertical-align: middle;
					}
				}
				.ss-recmd__content{
					height:57px;
					width: 205px;
					float: left;
					padding-left: 20px;
					position: relative;
				}
				.ss-recmd__text{
					font-size:16px;
					font-family:Source Han Sans CN;
					font-weight:400;
					color:rgba(91,91,91,1);
					line-height:18px;
					@include ellipsis();
				}
			}
		}
		.ss-recmd__title{
			font-size:18px;
			font-weight:400;
			color:rgba(34,34,41,1);
			line-height:24px;
			height:44px;
			padding: 10px;
			.fr{
				cursor: pointer;
				font-size:14px;
				font-weight:400;
				color:rgba(185,185,185,1);
				line-height:24px;
				img{
					width: 14px;
					display: inline-block;
					vertical-align: middle;
					margin-right: 5px;
				}
			}
		}
	}
</style>
